var map = {
	"./0_buddy_bunny.jpg": 7811,
	"./buddy_buildertruck.jpg": 7791,
	"./buddy_flower_pot.jpg": 8447,
	"./buddy_monkey.jpg": 5294,
	"./bumblebee_puppy.jpg": 1031,
	"./garden_play.jpg": 2075,
	"./halloween_kobi.jpg": 3909,
	"./harry_garden.jpg": 2689,
	"./hedgehog_puppy.png": 6674,
	"./kobi_mario.jpg": 4770,
	"./kobi_puppy_lap.jpg": 2805,
	"./koby_cute_face.jpg": 2989,
	"./koby_darkred.jpg": 5973,
	"./maggie_puppy.jpg": 824,
	"./missy_basket.jpg": 2695,
	"./missy_litter_basket.jpg": 1873,
	"./missy_litter_bed.jpg": 6772,
	"./newborn_girl_.jpg": 813,
	"./newborn_lap_puppy.jpg": 2132,
	"./newborn_puppy_boy.jpg": 4511,
	"./outside_feeding.jpg": 321,
	"./paddington_puppy.jpg": 8278,
	"./romeo_head_tilt.jpg": 6673,
	"./rosie_litter_in_box.jpg": 8380,
	"./rosie_puppy_pile.jpg": 592,
	"./sleepy_puppies.jpg": 7002,
	"./ted_pumpkin.png": 6115,
	"./toilet_training.jpg": 7275,
	"./truck_ted.png": 7375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;